<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title5">The Daring Debutantes Bundle</h1>
<p class="title6">M.C Beaton</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?130789aa